require('./dist/ui-bootstrap-tpls');

module.exports = 'ui.bootstrap';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-ui-bootstrap/index.js
 ** module id = 796
 ** module chunks = 8
 **/